import { Injectable } from '@angular/core';

export interface LightboxAlbum {
  src: string;
  thumb?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ImageLightboxService {

  private overlay: HTMLElement | null = null;
  private savedScrollY = 0;

  open(albums: LightboxAlbum[], index: number = 0, options?: any): void {
    this.close();

    const src = albums[index]?.src;
    if (!src) { return; }

    if (options?.disableScrolling) {
      this.savedScrollY = window.scrollY;
      document.body.style.overflow = 'hidden';
    }

    this.overlay = document.createElement('div');
    this.overlay.style.cssText =
      'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.85);' +
      'z-index:99999;display:flex;align-items:center;justify-content:center;cursor:pointer;';

    const img = document.createElement('img');
    img.src = src;
    img.style.cssText = 'max-width:90%;max-height:90%;object-fit:contain;border-radius:4px;box-shadow:0 4px 30px rgba(0,0,0,.5);';

    const closeBtn = document.createElement('span');
    closeBtn.innerHTML = '&times;';
    closeBtn.style.cssText =
      'position:absolute;top:20px;right:30px;font-size:40px;color:#fff;cursor:pointer;line-height:1;';

    this.overlay.appendChild(img);
    this.overlay.appendChild(closeBtn);
    document.body.appendChild(this.overlay);

    this.overlay.addEventListener('click', () => this.close());

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        this.close();
        document.removeEventListener('keydown', onKey);
      }
    };
    document.addEventListener('keydown', onKey);
  }

  close(): void {
    if (this.overlay) {
      this.overlay.remove();
      this.overlay = null;
      document.body.style.overflow = '';
    }
  }
}
